import React from 'react';
import PropTypes from 'prop-types';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { OptimizelyProvider } from '@optimizely/react-sdk';
import { ApplicationWrapper } from 'pages/ApplicationWrapper';
import '../main.scss';

Bugsnag.start({
	apiKey: process.env.BUGSNAG_CLIENT_KEY,
	plugins: [new BugsnagPluginReact()],
	releaseStage: `SFDC - ${process.env.NODE_ENV}`,
	onError(event) {
		event.addMetadata('Site - SFDC', {
			url: window.location.href,
		});
	},
});

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

export function App({ store, optimizelyClient, optimizelyUser }) {
	// Use server-provided user if available, else create from Redux state
	const visitId = store.getState().user.visitId;
	const user = optimizelyUser || { id: visitId };

	// Always render with OptimizelyProvider. If client is null, useDecision
	// hooks gracefully degrade to default values (enabled: false).
	return (
		<Provider store={store}>
			<OptimizelyProvider
				optimizely={optimizelyClient}
				user={user}
			>
				<ErrorBoundary>
					<BrowserRouter>
						<ApplicationWrapper />
					</BrowserRouter>
				</ErrorBoundary>
			</OptimizelyProvider>
		</Provider>
	);
}

App.propTypes = {
	store: PropTypes.object.isRequired,
	optimizelyClient: PropTypes.object,
	optimizelyUser: PropTypes.shape({
		id: PropTypes.string,
		attributes: PropTypes.object,
	}),
};

App.defaultProps = {
	optimizelyClient: null,
	optimizelyUser: null,
};

export default hot(module)(App);
